"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailGiven = exports.REASON_GIVEN = exports.userEvents = void 0;
const USER_ACTION = 'user_action';
const APPOINTMENT_CANCEL = 'appointment_cancel';
exports.userEvents = {
    CLICK_CANCEL_APPT: `${USER_ACTION}.${APPOINTMENT_CANCEL}.click.cancel_appointment`,
    CLICK_SIDEBAR_PHONE: `${USER_ACTION}.${APPOINTMENT_CANCEL}.click.phone_number_on_need_help`,
    CLICK_RESCHEDULE_CTA: `${USER_ACTION}.${APPOINTMENT_CANCEL}.click.reschedule_cta`,
    CLICK_NEW_SEARCH_CTA: `${USER_ACTION}.${APPOINTMENT_CANCEL}.click.new_search_cta`,
    APPT_CANCEL_FAIL: `${USER_ACTION}.${APPOINTMENT_CANCEL}.error.appt_cancelation_fail`,
    APPT_CANCEL_BACK_BUTTON_CLICK: `${USER_ACTION}.${APPOINTMENT_CANCEL}.click.cancel_appt_back_button`,
    CANCELLATION_REASON_SELECTED: `${USER_ACTION}.${APPOINTMENT_CANCEL}.click.cancellation_reason_selected`
};
exports.REASON_GIVEN = 'reason_given';
exports.emailGiven = 'email_given';
//# sourceMappingURL=Tracking.js.map